import React, { useState } from 'react';
import { useTokenSelector } from '../../../../hooks';

type Props = {
  idToken: number;
  userId: string;
};

const SelectTokenButton: React.FC<Props> = ({ idToken, userId }) => {
  const { tokens, selectTokenWithFeedback, isSelecting } = useTokenSelector();
  const [message, setMessage] = useState<string | null>(null);

  const isTaken = !!tokens[idToken];

  const handleClick = async () => {
    const { message } = await selectTokenWithFeedback({
      idToken,
    });

    setMessage(message);
  };

  return (
    <div>
      <button
        onClick={handleClick}
        disabled={isSelecting || isTaken}
        style={{
          padding: '10px 16px',
          backgroundColor: isTaken ? '#ccc' : '#4caf50',
          color: '#fff',
          border: 'none',
          cursor: isTaken ? 'not-allowed' : 'pointer',
        }}
      >
        {isTaken ? `Token ${idToken} ocupado` : `Seleccionar ${idToken}`}
      </button>

      {message && <p>{message}</p>}
    </div>
  );
};

export default SelectTokenButton;
